<template>
  <svg width="40" height="40" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path
        d="M34.5 12v8.533c0 .578-.468 1.046-1.045 1.046H9.89h0"
        :stroke="disabled ? disabledColor : color"
        stroke-width="3.554"
        stroke-linecap="round"
      />
      <path
        d="M34.5 12v8.533c0 .578-.468 1.046-1.045 1.046H9.89h0"
        :stroke="disabled ? disabledColor : color"
        stroke-width="3.554"
        stroke-linecap="round"
      />
      <path
        d="M3.641 22.74l8.444 4.621a1.254 1.254 0 001.857-1.1V17.02a1.254 1.254 0 00-1.857-1.1l-8.444 4.62a1.254 1.254 0 000 2.2z"
        :fill="disabled ? disabledColor : color"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class EnterIcon extends Vue {
  @Prop() disabled: boolean;
  @Prop({ type: String, default: 'var(--motif-500)'}) color: boolean;
  @Prop({ type: String, default: 'var(--motif-200)'}) disabledColor: boolean;

}
</script>
